import classNames from "classnames";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advanced from "dayjs/plugin/advancedFormat";
import { ImageIcon } from "components/molecules/ImageIcon";
import { Button, Typography } from "components/atoms";
import { useAppSelector, useScreenSize } from "hooks";
import {
  DASHBOARD_PROGRAME,
  DESKTOP_WIDTH,
  MOBILE_WIDTH,
  TAB_WIDTH,
} from "utils/constants";
import { CalenderIcon } from "components/atoms/Icon";
import image from "assets/Ellipse 155.png";
import { ConditionalTopicFocusPageBtns } from "./conditionalBtn";
import {
  useAddTopicFocusToCourseworkMutation,
  useLazyGetTopicFocusQuery,
  useRemoveTopicFocusFromCourseworkMutation,
} from "services/topicFocus";
import { decodeToken } from "utils/functions/decodeToken";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { google, outlook, yahoo, ics, CalendarEvent } from "calendar-link";
import { AddToExternalCalenderList } from "../TIle/AddToExternalCalenderList";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { getTimeZone } from "utils/functions/getTimeZone";
import { ai_mcat_chat_status } from "state/reducers/layoutSlice";
import {
  replaceArrayOfObjects,
  reStructureSegment,
} from "utils/functions/courseWorkReStructure";
import { getCategoryFilterInput } from "utils/functions/getCategoryFilterInput";
import { getTimeFilterInput } from "utils/functions/getTimeFilterInput";
import { useSegmentReFetch } from "context";
import "./index.scss";

interface IProps {
  borderColor: string;
  isTabShow: boolean;
  groups?: any;
  styles?: string;
  title: string;
  startTime?: string;
  endTime?: string;
  timeSpan?: string;
  profileImage?: string;
  messageIcon?: boolean;
  name?: string;
  btnLabel?: string;
  theme: "light" | "dark";
  btnType: string;
  segmentId: number;
  instructorId: string;
  isAddedToHome: boolean;
  item?: any;
  btnUrl?: string;
  index: number;
  page: any;
  setData: Dispatch<SetStateAction<any>>;
  data: any;
  selectedSession: null | string | { [key: number]: string };
  selectedCategory: null | string | { [key: number]: string };
  selectedSubject: any | undefined | { group: string; label: string };
  selectedTopic: any | undefined | { group: string; label: string };
  refetchStudyPlanner?: any;
  isFetchingOtherData?: boolean;
}

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);
const guessedTimezone = dayjs.tz.guess();

export const TopicFocusTile = ({
  borderColor = "black",
  styles,
  title = "Test 4",
  startTime = "Saturday. August 12",
  endTime = "10:00 AM - 5:00 PM EDT",
  timeSpan = "",
  profileImage,
  messageIcon,
  btnLabel,
  name,
  theme,
  btnType,
  segmentId,
  instructorId,
  isAddedToHome,
  item,
  btnUrl,
  index,
  page,
  setData,
  data,
  selectedSession,
  selectedCategory,
  selectedSubject,
  selectedTopic,
  refetchStudyPlanner,
  isFetchingOtherData,
}: IProps) => {
  const screen = useScreenSize();
  const payload = decodeToken();
  const [isExternalCalenderListShow, setIsExternalCalenderListShow] =
    useState(false);
  const [googleLink, setGoogleLink] = useState("");
  const [yahooLink, setYahooLink] = useState("");
  const [outLookLink, setOutLookLink] = useState("");
  const [icsLink, setIcsLink] = useState("");
  const [activeSegmentId, setActiveSegmentId] = useState<number | null>(null);
  const [localIsAddedToHome, setLocalIsAddedToHome] = useState(isAddedToHome);

  const calendarRefTopicFocus = useRef<HTMLDivElement>(null);

  const { aiMCATChatDrawerStatus } = useAppSelector(
    (state: { layout: { aiMCATChatDrawerStatus: ai_mcat_chat_status } }) =>
      state.layout
  );

  const isDashboard =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === DASHBOARD_PROGRAME;

  const [addToCoursework, { isLoading }] =
    useAddTopicFocusToCourseworkMutation();

  const [removeFromCoursework, { isLoading: isLoadingRemove }] =
    useRemoveTopicFocusFromCourseworkMutation();

  const { setPage } = useSegmentReFetch();

  const [triggerGetTopicFocus] = useLazyGetTopicFocusQuery();

  const handleRefreshTopicFocus = async () => {
    const promises = [
      triggerGetTopicFocus({
        page: page ? page : 1,
        selectedOption:
          selectedCategory === null
            ? 1
            : getCategoryFilterInput(Object.values(selectedCategory)[0]),
        ...(selectedSubject !== undefined && selectedSubject !== "Show all"
          ? { subject: selectedSubject }
          : {}),
        ...(selectedTopic !== undefined && selectedSubject !== "Show all"
          ? { topic: selectedTopic }
          : {}),
        ...(selectedSession !== undefined
          ? {
              timeFilter:
                selectedSession === null
                  ? 1
                  : getTimeFilterInput(Object.values(selectedSession)[0]),
            }
          : {}),
      }),
    ];

    Promise.allSettled(promises).then((responses: any) => {
      if (responses[0].status === "fulfilled") {
        const deStructuredArray = reStructureSegment(responses[0].value.data);
        const updatedArray = replaceArrayOfObjects(deStructuredArray, data);
        setData([...updatedArray]);
      }
    });
  };

  const handleClick = async (id: number) => {
    setActiveSegmentId(id);
    setLocalIsAddedToHome(true);

    try {
      await addToCoursework({ segmentId: id, page: page })
        .unwrap()
        .then(() => {
          if (isDashboard) {
            setPage(1);
            refetchStudyPlanner && refetchStudyPlanner();
            handleRefreshTopicFocus();
          } else {
            handleRefreshTopicFocus();
          }
        });
    } catch (error: any) {
      console.log("error ", error);
      setLocalIsAddedToHome(false);
    }
  };

  const handleRemove = async (id: number) => {
    setActiveSegmentId(id);
    setLocalIsAddedToHome(false);

    try {
      await removeFromCoursework({ productOfferingSegmentId: id, page: page })
        .unwrap()
        .then(() => {
          if (isDashboard) {
            setPage(1);
            refetchStudyPlanner && refetchStudyPlanner();
            handleRefreshTopicFocus();
          } else {
            handleRefreshTopicFocus();
          }
        });
    } catch (error) {
      console.log("error : ", error);
      setLocalIsAddedToHome(true); 
    }
  };

  const formatDate = (dateInput: string): string => {
    let date = dayjs.utc(dateInput).local().format("dddd, MMMM DD");
    return `${date}`;
  };

  const formatTimeRange = (dateTime: string): string => {
    let localTime = dayjs(dateTime).isValid()
      ? dayjs.utc(dateTime).local().format("hh:mm A")
      : dateTime;
    return localTime;
  };

  const handleAddToExternalCalender = (
    title: string,
    startTime: string,
    endTime: string
  ) => {
    let startTimeString = `${formatToLocalDate(startTime, "YYYY-MM-DD HH:mm:ss")} ${getTimeZone(startTime)}`;
    let endTimeString = `${formatToLocalDate(endTime, "YYYY-MM-DD HH:mm:ss")} ${getTimeZone(endTime)}`;

    const event: CalendarEvent = {
      title: title,
      start: startTimeString,
      end: endTimeString,
      description: "Online Classroom",
    };

    setGoogleLink(google(event));
    setOutLookLink(outlook(event));
    setYahooLink(yahoo(event));
    setIcsLink(ics(event));
    setIsExternalCalenderListShow((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      calendarRefTopicFocus.current &&
      !calendarRefTopicFocus.current.contains(event.target as Node)
    ) {
      setIsExternalCalenderListShow(false);
    }
  };

  const handleStyleWithDrower = () => {
    return (
      screen.width > DESKTOP_WIDTH &&
      screen.width < 1600 &&
      aiMCATChatDrawerStatus === "open"
    );
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (activeSegmentId && !isLoading && !isFetchingOtherData) {
      setActiveSegmentId(null);
    }
  }, [isLoading, isFetchingOtherData]);

  useEffect(() => {
    setLocalIsAddedToHome(isAddedToHome);
  }, [isAddedToHome]);

  const currentBtnType = localIsAddedToHome ? "active" : "score";

  return (
    <div className="topic-focus-tile-container">
      {
        <div
          className={classNames(
            "topic-focus-tile-wrapper",
            `default-border-${borderColor}`,
            handleStyleWithDrower()
              ? "topic-focus-tile-wrapper-for-drawer-style"
              : ""
          )}
        >
          <div
            className={classNames(
              "tile",
              { [`${styles}`]: styles },
              handleStyleWithDrower() ? "tile-for-drawer-style" : ""
            )}
          >
            {screen.width > MOBILE_WIDTH && screen.width <= TAB_WIDTH ? (
              <>
                <div className="tab-layout-detail-card">
                  <div className={classNames("content-section")}>
                    <div className="content-1">
                      <Typography label={title} variant="h5Bold" />
                    </div>
                    {screen.width < MOBILE_WIDTH ? (
                      <div className={classNames("image-section")}>
                        <ImageIcon
                          label="default label"
                          icon={messageIcon}
                          image={image}
                          styles="img-text-icon-tile"
                          theme={theme}
                        />
                      </div>
                    ) : null}
                    <div className="content-2">
                      <div>
                        <Typography
                          label={formatDate(startTime)}
                          variant="h7Med"
                        />
                      </div>

                      <div className="content-2-1">
                        <Typography
                          label={`${formatTimeRange(
                            startTime
                          )} - ${formatTimeRange(endTime)} ${dayjs()
                            .tz(guessedTimezone)
                            .format("z")}`}
                          variant="h8Book"
                          spanStyle="suggested-date-custom-style"
                        />
                        {screen.width < MOBILE_WIDTH ? (
                          <CalenderIcon
                            color={theme === "light" ? "black" : "white"}
                          />
                        ) : null}
                      </div>
                    </div>
                    {screen.width > MOBILE_WIDTH ? (
                      <div
                        className="content-3"
                        id={`content-3-${index}`}
                        ref={calendarRefTopicFocus}
                      >
                        <Button
                          label="Add To External Calendar"
                          icon={true}
                          type="icon-text"
                          onClick={() =>
                            handleAddToExternalCalender(
                              title,
                              startTime,
                              endTime
                            )
                          }
                        />

                        {isExternalCalenderListShow ? (
                          <AddToExternalCalenderList
                            icsLink={icsLink}
                            googleLink={googleLink}
                            yahooLink={yahooLink}
                            outLookLink={outLookLink}
                            setIsExternalCalenderListShow={
                              setIsExternalCalenderListShow
                            }
                          />
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                  <div
                    className={classNames(
                      "tab-layout-image-btn-section",
                      !profileImage && "non-image-btn"
                    )}
                  >
                    {profileImage ? (
                      <div className={classNames("image-section")}>
                        <ImageIcon
                          label={name ? name : "default name"}
                          icon={messageIcon}
                          image={profileImage}
                          styles="img-text-icon-tile"
                          theme={theme}
                        />
                      </div>
                    ) : null}
                    <div className={classNames("button-section")}>
                      {localIsAddedToHome ? (
                        <ConditionalTopicFocusPageBtns
                          onClick={handleClick}
                          startTime={startTime}
                          endTime={endTime}
                          segmentId={segmentId}
                          btnUrl={btnUrl}
                          index={index}
                          isLoading={isLoading}
                          handleRemove={handleRemove}
                          isLoadingRemove={isLoadingRemove}
                          isFetchingData={isFetchingOtherData}
                          activeSegment={activeSegmentId}
                        />
                      ) : (
                        <div className="btn-wrapper">
                          <Button
                            onClick={() => {
                              handleClick(segmentId);
                            }}
                            label="Add to Coursework"
                            type={currentBtnType}
                            icon={false}
                            styles="custom-tab-layout-btn-style"
                            isLoading={
                              (isLoading && activeSegmentId === segmentId) ||
                              (isFetchingOtherData &&
                                activeSegmentId === segmentId)
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  className={classNames(
                    "content-section",
                    handleStyleWithDrower()
                      ? "content-section-for-drawer-styles"
                      : ""
                  )}
                >
                  <div className="content-1">
                    <Typography label={title} variant="h5Bold" />
                  </div>
                  {profileImage &&
                  (screen.width < MOBILE_WIDTH || handleStyleWithDrower()) ? (
                    <div
                      className={classNames(
                        "image-section",
                        handleStyleWithDrower()
                          ? "image-section-for-drawer-style"
                          : ""
                      )}
                    >
                      <ImageIcon
                        label={name ? name : "default name"}
                        icon={messageIcon}
                        image={profileImage}
                        styles={`img-text-icon-tile ${
                          handleStyleWithDrower()
                            ? "img-text-icon-tile-for-drawer-styles"
                            : ""
                        }`}
                        theme={theme}
                      />
                    </div>
                  ) : null}
                  <div
                    className={classNames(
                      "content-2",
                      handleStyleWithDrower()
                        ? "content-2-for-drawer-styles"
                        : ""
                    )}
                  >
                    <div>
                      <Typography
                        label={formatDate(startTime)}
                        variant="h7Med"
                      />
                    </div>

                    <div
                      className={classNames(
                        "content-2-1",
                        handleStyleWithDrower()
                          ? "content-2-1-for-drawer-styles"
                          : ""
                      )}
                    >
                      <Typography
                        label={`${formatTimeRange(
                          startTime
                        )} - ${formatTimeRange(endTime)} ${dayjs()
                          .tz(guessedTimezone)
                          .format("z")}`}
                        variant="h8Book"
                        spanStyle="suggested-date-custom-style"
                      />
                      {/* {screen.width < MOBILE_WIDTH ? ( */}
                      {screen.width < MOBILE_WIDTH ||
                      handleStyleWithDrower() ? (
                        <div
                          className="mobile-calendar-list-wrapper"
                          ref={calendarRefTopicFocus}
                        >
                          <CalenderIcon
                            color={theme === "light" ? "black" : "white"}
                            onClick={() =>
                              handleAddToExternalCalender(
                                title,
                                startTime,
                                endTime
                              )
                            }
                          />
                          {isExternalCalenderListShow ? (
                            <AddToExternalCalenderList
                              icsLink={icsLink}
                              googleLink={googleLink}
                              yahooLink={yahooLink}
                              outLookLink={outLookLink}
                              setIsExternalCalenderListShow={
                                setIsExternalCalenderListShow
                              }
                            />
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {/* {screen.width > MOBILE_WIDTH ? ( */}
                  {screen.width > MOBILE_WIDTH && !handleStyleWithDrower() ? (
                    <div
                      className="content-3"
                      id={`content-3-${index}`}
                      ref={calendarRefTopicFocus}
                    >
                      <Button
                        label="Add To External Calendar"
                        icon={true}
                        type="icon-text"
                        onClick={() =>
                          handleAddToExternalCalender(title, startTime, endTime)
                        }
                      />

                      {isExternalCalenderListShow ? (
                        <AddToExternalCalenderList
                          icsLink={icsLink}
                          googleLink={googleLink}
                          yahooLink={yahooLink}
                          outLookLink={outLookLink}
                          setIsExternalCalenderListShow={
                            setIsExternalCalenderListShow
                          }
                        />
                      ) : null}
                    </div>
                  ) : null}
                </div>
                {profileImage &&
                screen.width > MOBILE_WIDTH &&
                !handleStyleWithDrower() ? (
                  <div className={classNames("image-section")}>
                    <ImageIcon
                      label={name ? name : "default name"}
                      icon={messageIcon}
                      image={profileImage}
                      styles="img-text-icon-tile"
                      theme={theme}
                    />
                  </div>
                ) : null}
                <div
                  className={classNames(
                    "button-section",
                    handleStyleWithDrower()
                      ? "button-section-for-drawer-styles"
                      : ""
                  )}
                >
                  {localIsAddedToHome ? (
                    <ConditionalTopicFocusPageBtns
                      onClick={handleClick}
                      startTime={startTime}
                      endTime={endTime}
                      segmentId={segmentId}
                      btnUrl={btnUrl}
                      index={index}
                      isLoading={isLoading}
                      handleRemove={handleRemove}
                      isLoadingRemove={isLoadingRemove}
                      isFetchingData={isFetchingOtherData}
                      activeSegment={activeSegmentId}
                    />
                  ) : (
                    <div className="btn-wrapper">
                      <Button
                        onClick={() => {
                          handleClick(segmentId);
                        }}
                        label="Add to Coursework"
                        type={currentBtnType}
                        icon={false}
                        styles="custom-tab-layout-btn-style"
                        isLoading={
                          (isLoading && activeSegmentId === segmentId) ||
                          (isFetchingOtherData && activeSegmentId === segmentId)
                        }
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      }
    </div>
  );
};
